import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterFiltroContratos(filtroDto) {
        const parametrosUrl = filtroDto.dataPagamentoDe
            ? `/?dtPagamentoDe=${filtroDto.dataPagamentoDe}&dtPagamentoAte=${filtroDto.dataPagamentoAte}`
            : ''
        return axiosJwt
            .get(
                `${api}/gescon/contrato/tcurelatorio/planilha${parametrosUrl}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterFiltroProjetos(filtroProjetosDto) {
        const modulo = obterModuloProjetoComoString(filtroProjetosDto.modulo);
        const parametrosUrl = filtroProjetosDto.dataPagamentoDe
            ? `/?DataPagamentoDe=${filtroProjetosDto.dataPagamentoDe}&DataPagamentoAte=${filtroProjetosDto.dataPagamentoAte}&modulo=${modulo}`
            : ''
        return axiosJwt
            .get(
                `${api}/sgtec/projetos/tcurelatorio/planilha${parametrosUrl}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterFiltroContratacao(filtroContratacaoDto){
        const parametrosUrl = filtroContratacaoDto.dataPagamentoDe
            ? `/?DataPagamentoDe=${filtroContratacaoDto.dataPagamentoDe}&DataPagamentoAte=${filtroContratacaoDto.dataPagamentoAte}`
            : ''
        return axiosJwt
            .get(
                `${api}/sgf/contratacoes/tcurelatorio/planilha${parametrosUrl}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterFiltroLicitantesSgtec(filtro) {
        let url = `${api}/sgtec/relatorios/licitantes?dataInicial=${filtro.dataInicial ? filtro.dataInicial : ''
            }&dataFinal=${filtro.dataFinal ? filtro.dataFinal : ''}`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterFiltroBolsistas(filtro) {
        let url = `${api}/gescon/contrato/tcurelatorio/bolsistas/planilha?dataInicial=${filtro.dataInicial ? filtro.dataInicial : ''
            }&dataFinal=${filtro.dataFinal ? filtro.dataFinal : ''}`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}

function obterModuloProjetoComoString(modulo) {
    switch (modulo) {
        case 1:
            return 'SEBRAETEC'
        case 2:
            return 'SGF'
        case 3:
            return 'TODOS'
        default:
            return ''
    }
}
